export default __webpack_public_path__ + "static/media/mobile_order_blur.f12d28d1.png";